<script>
  import { cart } from './storage.js';
  import CartItem from  './CartItem.svelte';

  let { onrefresh } = $props();

  const compare = (a, b) => (a.id - b.id);
</script>


<div class="products">
  {#each [...$cart.order_items].sort(compare) as item}
    <CartItem {item} {onrefresh} />
  {:else}
    Pusty koszyk.
  {/each}
</div>


<style>
  .products {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  @media (max-width: 767px) {
    .products {
      background-color: transparent;
      padding: 0;
      margin-bottom: 0;
    }
  }
</style>
